import styled from "@emotion/styled";
import Radio from "@mui/material/Radio";

import TickIcon from "./tick-icon.svg";

export const GrayCircle = styled.div`
  inline-size: 24px;
  block-size: 24px;

  border-radius: 50%;

  background-color: #d7d7d7;
`;

export const StyledRadio = styled(Radio)`
  padding: 0;
`;

export const StyledTickIcon = styled(TickIcon)``;
